import "../../shared/components/wizard_modal.js";

window.Sparkle ??= {};

Sparkle.ThumbnailEditorModal = class ThumbnailEditorModal extends window.WizardModal {
  constructor(thumbnailEditor, title) {
    super({ class: "admin-modal thumbnail-editor-modal" });
    this.show = this.show.bind(this);
    this.showPage = this.showPage.bind(this);
    this.setThumbnail = this.setThumbnail.bind(this);
    this._removeThumbnail = this._removeThumbnail.bind(this);
    this._updateRemoveButton = this._updateRemoveButton.bind(this);
    this._showingRemoveableThumbnail = this._showingRemoveableThumbnail.bind(this);
    this.thumbnailEditor = thumbnailEditor;
    this.addPage({ header: title, body: this.thumbnailEditor.el });
    this.removeButton = jQuery('<span class="nav-button--left btn remove-thumbnail-button"></span>');

    // BEHAVIOUR

    jQuery(this.thumbnailEditor).on("setThumbnail", this._updateRemoveButton);
    jQuery(this.removeButton).on("click", this._removeThumbnail);
  }

  // HELPER METHODS

  show(_) {
    super.show();
    // Render after the modal is visible to ensure cropper element dimensions are measured correctly
    return this.thumbnailEditor.render();
  }

  showPage(_) {
    super.showPage(_);
    return this._updateRemoveButton();
  }

  setThumbnail(thumbnail, { defaultThumbnail }) {
    this.thumbnail = thumbnail;
    this.defaultThumbnail = defaultThumbnail;
    return this.thumbnailEditor.setThumbnail(this.thumbnail || this.defaultThumbnail);
  }

  // PRIVATE

  _removeThumbnail() {
    return this.thumbnailEditor.setThumbnail(this.defaultThumbnail).then(this.thumbnailEditor.render);
  }

  _updateRemoveButton() {
    this.removeButton.detach();

    const removeText = this.defaultThumbnail ? "Reset to Default" : "Remove Thumbnail";
    this.removeButton.html(removeText);

    if (this._showingRemoveableThumbnail()) {
      return this.navigationElements.nav.prepend(this.removeButton);
    }
  }

  _showingRemoveableThumbnail() {
    if (!this.thumbnailEditor.hasThumbnail()) {
      return false;
    }
    if (!this.defaultThumbnail) {
      return true;
    }

    return this.thumbnailEditor.getThumbnail().originalUrl !== this.defaultThumbnail.originalUrl;
  }
};
